export default "__VITE_ASSET__96e917ae__"